import React from "react"
import { Chip, Grid, Typography } from "@mui/material"
import { RentalDatesMultiPicker } from "@components"
import useReportMultipleModalMultipleEdit from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions/useEditMultiple"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"
import { AlertSeeker } from "@ui-seeker/core"


export default function ReportMultiModalDateSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()

	return <Grid container spacing={2}>
		<Grid item xs={3} sx={{ borderBottom: "2px solid", borderColor: "primary.main" }}>
			<Typography variant="h5">Edit Multiple Dates:</Typography>
		</Grid>
		<Grid item xs={12}>
			<AlertSeeker
				disableAccordion
				isOpen={true}
				severity="warning"
				title="Watch Out!"
				open={true}
			>
				<Typography variant="body1" color="textSecondary" paragraph>
					This multiple selector only works for those reports that have Rental Dates selected!
				</Typography>
			</AlertSeeker>
		</Grid>
		<Grid item xs={6}>
			<RentalDatesMultiPicker
				value={data}
				onChange={e => setData(e)}
				inputProps={{ sx: { backgroundColor: "background.grey" } }}
			/>
		</Grid>
		<Grid item xs={12}>
			<ReportMultiModalDatesDetails/>
		</Grid>
	</Grid>
}


function ReportMultiModalDatesDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="subtitle2">Affected reports:</Typography>
		</Grid>
		<Grid item xs={12} sx={{ maxWidth: "800px", overflowX: "auto", pb: 2 }}>
			<Grid container spacing={2}>
				{reportsInfo.value.map(({ name, rentalDateOptionTranslation, specificDates }, idx) => {
					return <Grid
						item
						xs={12}
						key={`${name}-${idx}`}
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "start",
							gap: 1,
						}}>
						<Typography variant="subtitle2" color="secondary.light">{name}:</Typography>
						{specificDates?.map((value, idx) => <Chip
							key={`${value}-${idx}`}
							label={formatDate(value.split("T")[0], {
								receivedFormat: dateFormatReceiver(value.split("T")[0]),
								isString: true
							})}
						/>) || <Typography
							variant="subtitle2"
							sx={{
								backgroundColor: "warning.light",
								p: .2,
								borderRadius: "5px",
								color: "warning.dark",
								fontWeight: "bold",
							}}>
							Not Affected
						</Typography>}
					</Grid>
				})}
			</Grid>
		</Grid>
	</Grid>
}